// extracted by mini-css-extract-plugin
export default {"main_operation":"main-operation_main_operation__se-nx"};